import { render, staticRenderFns } from "./CustomReportPage3.vue?vue&type=template&id=1cafe71c&scoped=true&"
import script from "./CustomReportPage3.vue?vue&type=script&lang=js&"
export * from "./CustomReportPage3.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportPage3.vue?vue&type=style&index=0&id=1cafe71c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cafe71c",
  null
  
)

export default component.exports